import React from 'react';

export const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M5 5L10 10M15 15L10 10M10 10L15 5M10 10L5 15"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ThumbUpIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      d="M10.2487 3.62449C9.76874 3.59101 9.43325 4.02764 9.30774 4.49211C9.21066 4.85133 9.06427 5.2869 8.85246 5.68608C8.42656 6.48873 7.10577 8.42079 6.8481 8.79595C6.81858 8.83894 6.7924 8.88298 6.76802 8.92907C6.64306 9.16525 6.50752 9.37206 6.08798 9.52038L5.41467 9.66834C4.9454 9.78129 4.55664 10.1284 4.55664 10.9119L4.62981 13.9293C4.62981 14.3887 4.94816 14.7812 5.39078 14.9043C5.52173 14.9407 5.65052 14.9942 5.74569 15.0912C6.24013 15.5953 6.99144 15.8747 7.62796 16.0349C8.35094 16.1979 8.94803 16.2502 10.4144 16.343C12.0249 16.4448 13.4442 16.3319 13.6809 16.343C14.1991 16.3673 14.8156 16.4212 15.2074 15.7129C15.3748 15.4101 15.7166 14.6692 15.5392 14.4966C15.424 14.3844 15.4588 14.2826 15.6239 14.2826C15.8937 14.2826 16.2007 12.6562 16.0206 12.479C15.8979 12.3582 15.9154 12.2818 16.0519 12.2277C16.2524 12.1483 16.3757 10.4481 16.2023 10.3236C16.0288 10.199 16.0209 10.1276 16.2023 10.0247C16.4077 9.90806 16.4341 8.62221 16.2023 8.26102C15.9552 7.87617 15.7362 7.7343 14.9027 7.7343C14.9027 7.7343 13.8755 7.70291 12.8245 7.7343C11.7735 7.76568 10.775 7.86174 10.775 7.86174C12.2962 4.76236 11.346 3.70101 10.2487 3.62449Z"
      stroke="white"
      strokeWidth="1.53073"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ThumbDownIcon = () => (
  <div style={{ transform: 'rotate(180deg)' }}>
    <ThumbUpIcon />
  </div>
);


